import Input from "../../../common/Input";

const PrimaryDetails = ({
  handleChange,
  values,
  errors,
  touched,
  setFieldTouched,
  isEdit,
  handleEditIconClick,
  handleBlur,
  editingField,
  isDisabled,
}) => {
  // const { handleChange, values, errors, touched, setFieldTouched } = formik;

  return (
    <div className="mb-3">
      <h2 className="text-black-lose text-[13px] font-medium mb-2">Primary</h2>
      <div className="grid grid-cols-12 gap-[8px]">
        {values?.storeDetails?.SID && (
          <div className="col-span-3">
            <Input
              placeholder="Enter"
              inputBox="mb-0"
              type="text"
              labelName="Store ID"
              labelClassName="block text-primary-400 text-[13px] leading-[20px]"
              className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
              name="storeDetails.SID"
              value={values?.storeDetails?.SID}
              onChange={handleChange}
              disabled
            />
          </div>
        )}
        <div className="col-span-3">
          <Input
            placeholder="Enter"
            inputBox="mb-0"
            type="text"
            labelName="Title*"
            id="storeDetails.title"
            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
            className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
            name="storeDetails.title"
            value={values?.storeDetails?.title}
            onChange={handleChange}
            isError={
              touched?.storeDetails?.title &&
              Boolean(errors?.storeDetails?.title)
            }
            errorMessage={errors?.storeDetails?.title}
            disabled={isDisabled && editingField !== "storeDetails.title"}
            showEditIcon={isEdit}
            onBlur={() => (handleBlur ? handleBlur("storeDetails.title") : "")}
            onEditClick={() => handleEditIconClick("storeDetails.title")}
            disabledClass="bg-primary-50 border-primary-50 "
          />
        </div>
        <div className="col-span-3">
          <Input
            placeholder="Enter"
            inputBox="mb-0"
            type="text"
            id="storeDetails.username"
            labelName="Username*"
            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
            className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
            name="storeDetails.username"
            value={values?.storeDetails?.username}
            onChange={(e) => {
              handleChange(e);
              setFieldTouched("storeDetails.username", true, false);
            }}
            isError={
              touched?.storeDetails?.username &&
              Boolean(errors?.storeDetails?.username)
            }
            errorMessage={errors?.storeDetails?.username}
            disabled={isDisabled && editingField !== "storeDetails.username"}
            showEditIcon={isEdit}
            onBlur={() =>
              handleBlur ? handleBlur("storeDetails.username") : ""
            }
            onEditClick={() => handleEditIconClick("storeDetails.username")}
            disabledClass="bg-primary-50 border-primary-50 "
          />
        </div>
        <div className="col-span-3">
          <Input
            placeholder="Enter"
            inputBox="mb-0"
            type="text"
            labelName="PIN (6-digit)*"
            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
            className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
            name="storeDetails.pin"
            id="storeDetails.pin"
            value={values?.storeDetails?.pin}
            onChange={(e) => {
              handleChange(e);
              setFieldTouched("storeDetails.pin", true, false); // Mark the field as touched
            }}
            isError={
              touched?.storeDetails?.pin && Boolean(errors?.storeDetails?.pin)
            }
            errorMessage={errors?.storeDetails?.pin}
            disabled={isDisabled && editingField !== "storeDetails.pin"}
            showEditIcon={isEdit}
            onBlur={() => (handleBlur ? handleBlur("storeDetails.pin") : "")}
            onEditClick={() => handleEditIconClick("storeDetails.pin")}
            disabledClass="bg-primary-50 border-primary-50 "
          />
        </div>
      </div>
    </div>
  );
};

export default PrimaryDetails;
